<script setup>
import { computed } from 'vue';

import { HrCircularProgress, HrIcon } from '../primitives';

/**
 * Countdown ring — a circular progress ring with a center icon for timers and timed steps.
 *
 * @status recommended
 * @group status-feedback
 * @useWhen Showing time or steps remaining in a timed or sequential flow
 * @related HrCompletionIndicator
 */
defineOptions({ name: 'HrCountdownRing' });

const props = defineProps({
  /**
   * Current progress value.
   * @example 30
   */
  value: {
    type: Number,
    required: true,
  },
  /**
   * Maximum value. Set to the total duration or count — not always 100.
   */
  max: {
    type: Number,
    default: 100,
  },
  /**
   * Material Symbols icon name shown in the center of the ring.
   * @example timer
   */
  icon: {
    type: String,
    required: true,
  },
});

// @todo Remove when legacy theme is removed.
const legacyProps = computed(() => ({
  'track-color': 'transparent',
  thickness: 0.2,
}));
</script>

<template>
  <hr-circular-progress
    :value="props.value"
    :max="props.max"
    size="40px"
    color-role="on-surface"
    track-variant="transparent"
    instant-feedback
    show-value
    :legacy-props="legacyProps"
  >
    <hr-icon
      :name="props.icon"
      size="xs"
    />
  </hr-circular-progress>
</template>
